import React, { PropsWithChildren } from 'react'
import { IonCard, IonLabel } from '@ionic/react'

import './styles/emptyImage.less'
import { formatNumberStyle } from '../../platform'

interface Props {
	height: number
	width: number
	title?: string
	onClick?(): void
}

const EmptyImage: React.FC<PropsWithChildren<Props>> = props => {
	const { width, height, title } = props

	return (
		<IonCard
			className="empty-image"
			style={{ width: formatNumberStyle(width), height: formatNumberStyle(height) }}
			onClick={props.onClick}
		>
			{title && (
				<IonLabel>
					<h2 className="subheading">{title}</h2>
				</IonLabel>
			)}

			{props.children}
		</IonCard>
	)
}

export default EmptyImage
